/* global swal  angular*/
import './style.less';
import moment from 'moment-timezone';
import './style.less';

import addIntegrationTemplate from 'modals/addIntegration/template.html';
import addIntegrationController from 'modals/addIntegration/index';

export default function($log, $uibModal, TimeZoneClass) {
  'ngInject';

  const vm = this;
  const userGuessedTimeZoneId = moment.tz.guess();

  vm.$onInit = activate;
  vm.activate = activate;
  vm.timeZoneList = TimeZoneClass.selectObjList;

  vm.addIntegration = function() {
    $uibModal
      .open({
        template: addIntegrationTemplate,
        backdrop: 'static',
        size: 'lg',
        windowClass: 'modal',
        controller: addIntegrationController(vm.event)
      })
      .result.then(external => {
        vm.event.externals.push(external);
      })
      .catch(error => {
        if (error === 'backdrop click' || error === 'cancel') return;
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    $log.debug('Webinar Editor Component Activated');
    vm.event.externals = vm.event.externals || [];
    vm.error = false;
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/externalEditor/controller.js